import React from "react";

const styles = {
  page: {
    fontFamily: "PoppinsCustom, sans-serif",
    background: "#f6faf7",
    minHeight: "100vh",
    padding: "120px 20px 60px",
    display: "flex",
    justifyContent: "center"
  },
  container: {
    width: "100%",
    maxWidth: 900,
    background: "#fff",
    borderRadius: 14,
    padding: "50px 60px",
    boxShadow: "0 10px 40px rgba(0,0,0,0.08)"
  },
  title: {
    fontSize: 34,
    fontWeight: 900,
    marginBottom: 20
  },
  sectionTitle: {
    fontSize: 20,
    fontWeight: 800,
    marginTop: 30,
    marginBottom: 10
  },
  text: {
    fontSize: 16,
    color: "#444",
    lineHeight: 1.8,
    marginBottom: 12
  },
  list: {
    paddingLeft: 20,
    marginBottom: 16,
    color: "#444",
    lineHeight: 1.8
  }
};

export default function LegalPage({ title, children }) {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.title}>{title}</h1>
        <div>{children}</div>
      </div>
    </div>
  );
}

export const H2 = ({ children }) => (
  <h2 style={styles.sectionTitle}>{children}</h2>
);

export const P = ({ children }) => (
  <p style={styles.text}>{children}</p>
);

export const UL = ({ children }) => (
  <ul style={styles.list}>{children}</ul>
);